/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconPriceLightBulb = StyledIconInline.extend`
  height: ${props => props.height || '25px'};
  width: ${props => props.width || '21px'};
  transform: translateY(1px);
`;

export const IconPriceLightBulb = (props) => (
    <StyledIconPriceLightBulb {...props}>
        <svg viewBox="0 0 21 25" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path
                    d="M12.25,18.979 L12.25,21.15 C12.25,22.35 11.278,23.322 10.079,23.322 C8.879,23.322 7.907,
                    22.35 7.907,21.15 L7.907,18.979"/>
                <path d="M12.25,18.979 C12.25,18.979 12.269,16.881 14.708,14.442 L14.707,14.442 C15.873,
                13.265 16.593,11.646 16.593,9.859 C16.593,6.26 13.677,3.344 10.079,3.344 C6.48,3.344 3.564,
                6.26 3.564,9.859 C3.564,11.646 4.285,13.265 5.451,14.442 L5.449,14.442 C7.918,16.91 7.907,
                18.979 7.907,18.979"/>
                <path d="M12.6938,19.9082 L7.5028,20.6502"/>
                <path d="M12.6743,18.1738 L7.5033,18.9128"/>
                <path d="M12.6938,21.6455 L8.2288,22.2835"/>
                <path d="M18.6104,9.7843 L19.5404,9.7843"/>
                <path d="M0.6167,9.7843 L1.5467,9.7843"/>
                <path d="M10.0781,1.356 L10.0781,0.426"/>
                <path d="M16.1943,3.6685 L16.8903,2.9725"/>
                <path d="M3.2671,16.5952 L3.9871,15.8752"/>
                <path d="M16.1846,15.8902 L16.8906,16.5952"/>
                <path d="M3.2671,2.9727 L4.0561,3.7617"/>
                <path d="M8.36375,11.19165 L10.89975,11.19165"/>
                <path d="M11.64355,8.84595 C11.34655,8.50245 10.90755,8.21095 10.41805,8.21095 C9.61205,
                8.21095 9.09005,8.64295 8.90355,9.42345 C8.82055,9.76795 8.83505,10.12745 8.90355,
                10.47495 C9.04655,11.20445 9.41105,12.80295 8.38355,13.67295 C8.38355,13.67295 9.30355,
                12.88495 10.30255,13.45195 C11.30155,14.01895 11.73355,13.31695 11.73355,13.31695"/>
            </g>
        </svg>
    </StyledIconPriceLightBulb>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconPriceLightBulb/index.js